import { css } from 'styled-components';
import { IconWrapper } from '../../../../components/Cta/styles';
import CardSection from '../../../../components/Header/DoubleHeader/CardSection';
import spacing from '../../../../helpers/spacing';

export default css`
  ${CardSection} {
    ${IconWrapper} {
      margin-left: ${spacing(1)};
    }
  }
`;
